// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class ProductGallery extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="product-gallery.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="product-gallery.slide"]')
    this.dotEls = this.querySelectorAll('[data-el="product-gallery.dot"]')
    this.thumbEls = this.querySelectorAll('[data-el="product-gallery.thumb"]')
    this.closeEl = this.querySelector(
      '[data-el="product-gallery.closeGallery"]',
    )

    this.photoswipeEl = this.querySelector(
      '[data-el="product-gallery.photoswipe"]',
    )
    this.popupGallery = this.querySelector(
      '[data-el="product-gallery.popupGallery"]',
    )
    this.popupGallerySlidesEl = this.querySelector(
      '[data-el="product-gallery.popupGallerySlides"]',
    )
    this.popupGallerySlideEls = this.querySelectorAll(
      '[data-el="product-gallery.popupGallerySlide"]',
    )

    this.popupGalleryThumbEls = this.querySelectorAll(
      '[data-el="product-gallery.popupGalleryThumb"]',
    )

    this.desktopVideoEl = this.querySelector(
      '[data-el="product-gallery.desktopVideo"]',
    )
    this.mobileVideoEl = this.querySelector(
      '[data-el="product-gallery.mobileVideo"]',
    )

    const desktopVideoBackgroundElement = document.querySelector(
      '.sec-Background_Video-desktop source',
    )
    const mobileVideoBackgroundElement = document.querySelector(
      '.sec-Background_Video-mobile source',
    )
    this.desktopVideoBackgroundSource = desktopVideoBackgroundElement
      ? desktopVideoBackgroundElement.src
      : null
    this.mobileVideoBackgroundSource = mobileVideoBackgroundElement
      ? mobileVideoBackgroundElement.src
      : null

    if (this.desktopVideoEl && this.desktopVideoBackgroundSource) {
      this.desktopVideoEl
        .querySelector('source')
        .setAttribute('src', this.desktopVideoBackgroundSource)
      this.desktopVideoEl.load()
    }

    // if (this.slideEls.length < 2) return

    this.slideEls.forEach(el => {
      el.addEventListener('click', e => {
        this.popupGalleryOpen(el.dataset.slideIndex)
      })
    })

    this.popupGalleryThumbEls.forEach(popupGalleryThumbEl => {
      popupGalleryThumbEl.addEventListener('click', event => {
        this.popupGalleryGoToSlide(event.currentTarget.dataset.slide)
      })
    })

    this.carousel = this.initialiseCarousel()
  }

  popupGalleryOpen (slideIndex) {
    const images = JSON.parse(this.photoswipeEl.dataset.images)
    const size = {
      width: 1327,
      height: 1990,
    }

    this.gallery = new window.PhotoSwipe(
      this.photoswipeEl,
      window.PhotoSwipeUI_Default,
      images.map(image => ({
        src: window.BAO.utils.resizeImage({
          src: image,
          size: `${size.width}x${size.height}`,
        }),
        w: size.width,
        h: size.height,
      })),
      { index: slideIndex },
    )

    this.gallery.init()

    this.gallery.listen('afterChange', () => {
      const currentIndex = Number(this.gallery.getCurrentIndex())
      this.popupGalleryThumbEls.forEach((popupGalleryThumbEl, index) => {
        popupGalleryThumbEl.setAttribute('aria-current', index === currentIndex)
      })
    })
  }

  initialiseCarousel () {
    return new KeenSlider(this.slidesEl, {
      duration: 0,
      loop: true,
      slides: this.slideEls.length,
      move: instance => {
        this.slideEls.forEach((slide, index) => {
          slide.setAttribute(
            'aria-hidden',
            index !== instance.details().relativeSlide,
          )
        })
      },
      created: instance => {
        this.dotEls.forEach(dot => {
          dot.addEventListener('click', () => {
            instance.moveToSlide(dot.dataset.slide)
          })
        })
        this.thumbEls.forEach(thumb => {
          thumb.addEventListener('click', () => {
            instance.moveToSlide(parseInt(thumb.dataset.slide))
          })
        })
      },
      slideChanged: instance => {
        this.dotEls.forEach(dot => {
          dot.setAttribute(
            'aria-current',
            parseInt(dot.dataset.slide) === instance.details().relativeSlide,
          )
        })
        this.thumbEls.forEach(thumb => {
          thumb.setAttribute(
            'aria-current',
            parseInt(thumb.dataset.slide) === instance.details().relativeSlide,
          )
        })
      },
    })
  }

  popupGalleryGoToSlide (slideIndex) {
    if (this.gallery) {
      this.gallery.goTo(slideIndex)
    }
  }
}

customElements.define('product-gallery', ProductGallery)